import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import styles from "./SkeletonList.module.scss";

const SkeletonList = () => {
  return (
    <>
      <Skeleton className={styles["Skeleton"]} />
      <Skeleton className={styles["Skeleton"]} />
      <Skeleton className={styles["Skeleton"]} />
      <Skeleton className={styles["Skeleton"]} />
    </>
  );
};

export default SkeletonList;
